<template>
    <section>
        <v-btn text class="px-0 green--text back" @click="$router.go(-1)" absolute v-if="$vuetify.breakpoint.mdAndDown">
            <svg v-svg="'icon-back'" size="11" fill="currentColor" class="mr-1"></svg>
            <span>Back</span>
        </v-btn>

        <h1 class="mt-5 mb-3 text-center">Quizzes</h1>

        <v-data-table :headers="headers"
                      :items="quizzes"
                      :page.sync="pagination.current"
                      :items-per-page="pagination.rowsPerPage"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{(pagination.current - 1)*pagination.rowsPerPage+props.index+1}}
            </template>

            <template v-slot:item.type="props">
                {{props.item.type === 3 ? 'In Writing' : 'Selectable'}}
            </template>

            <template v-slot:item.status="props">
                {{props.item.status ? 'Active' : 'Inactive'}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 mr-1" @click="[$refs.edit.dialog = true, selectedQuiz = props.item.id]">
                    <svg v-svg="'icon-edit'" size="12" class="mr-1"></svg>
                    <span class="green--text">Edit</span>
                </v-btn>

                <v-btn text class="px-0 mx-2" @click="[$refs.delete.dialog = true, selectedQuiz = props.item.id]">
                    <svg v-svg="'icon-delete'" size="12" class="mr-1"></svg>
                    <span class="red--text">Delete</span>
                </v-btn>

                <v-btn text :loading="loadingToggle" @click="toggleStatus(props.item.id)" class="px-0 ml-1"
                       :class="{'inactivate': props.item.status , 'activate': !props.item.status}">
                    <svg v-svg="'icon-status'" size="12" class="mr-1" fill="currentColor"></svg>
                    <span v-if="props.item.status">Inactivate</span>
                    <span v-else>Activate</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <div class="float-end mb-5">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>

        <v-btn color="green" width="52" height="52" class="create" fab fixed bottom @click="$refs.create.dialog = true">
            <svg v-svg="'icon-create'" size="21"></svg>
        </v-btn>

        <edit ref="edit" :quiz_id="selectedQuiz"></edit>
        <delete ref="delete" :quiz_id="selectedQuiz"></delete>
        <create ref="create"></create>
    </section>
</template>

<script>
    import Edit from '@/components/Admin/Quizzes/Edit';
    import Delete from '@/components/Admin/Quizzes/Delete';
    import Create from '@/components/Admin/Quizzes/Create';
    export default {
        components : {
            Edit,
            Delete,
            Create,
        },
        data(){
            return {
                loadingRequest: false,
                loadingToggle: false,
                selectedQuiz: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: 'Title', sortable: false, value: 'title'},
                    {text: 'Subject', sortable: false, value: 'course_name'},
                    {text: 'Type', sortable: false, value: 'type'},
                    {text: 'Status', sortable: false, value: 'status'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right', width: '270px'}
                ],
                pagination: {},
                quizzes: [],
            }
        },

        mounted(){
            this.getData();
            this.$on('getQuizzes', function () {
                this.getData();
            })
        },

        methods: {
            toggleStatus(id) {
                this.loadingToggle = true;
                this.$apiAdmin('quizzes').enableDisable(id).then(() => {
                    this.quizzes.map((item) => {
                        if(item.id === id)
                            item.status = !item.status;
                        return item;
                    })
                    this.$store.dispatch('alert', {type: 1, message: 'Successfully updated.'});
                }).finally(() => {
                    this.loadingToggle = false;
                });
            },

            getData(page) {
                this.loadingRequest = true;
                this.$apiAdmin('quizzes').get({params: {page: page, course_id: this.$route.query.subject_id}}).then((res) => {
                    const response = res.data.quizzes;
                    this.pagination.rowsPerPage = response.per_page;
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.quizzes = response.data;
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/tablePages";
    @import "../../../scss/pages/Quizzes/index";
</style>